import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import "./UiLoader.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiLoader',
  props: {
  size: { type: Number, default: 24 },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    class: "UiLoader"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})